import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMultiSelectRemoveCarrier extends Layout {
    labelTonuDisclaimer: Label;
    labelTotalRequestCount: Label;
    labelTotalRequests: Label;
    sourceBrokerageMovements: DataSource;
    tableMovements: Table;
}
